<template>
  <v-navigation-drawer color="menu" app v-model="drawer" temporary width="400">
    <v-list nav dense>
      <account></account>
      <div v-for="item in menuItems" v-bind:key="item.id">
        <v-list dense v-if="item.subItems.length == 0">
          <v-list-item :data-cy="item.id" :to="item.to">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon
              >{{ item.text }}
            </v-list-item-icon>
          </v-list-item>
        </v-list>
        <v-list-group color="accent" :data-cy="item.id" v-else no-action :value="false">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon
              >{{ item.text }}
            </v-list-item-icon>
          </template>
          <v-list-item
            :data-cy="subItem.id"
            v-for="subItem in item.subItems"
            v-bind:key="subItem.text"
            :to="subItem.to"
          >
            <v-list-item-icon>
              <v-icon>{{ subItem.icon }}</v-icon
              >{{ subItem.text }}
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
      </div>
      <v-list-item data-cy="menu-localization" @click="onToggleLocalization">
        <v-list-item-icon>
          <v-icon>mdi-swap-horizontal</v-icon> {{ localize }}
        </v-list-item-icon>
      </v-list-item>
      <v-list-item data-cy="menu-theme" @click="onToggleTheme">
        <v-list-item-icon>
          <v-icon>mdi-theme-light-dark</v-icon> {{ theme }}
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import account from "./account"
import breakpointMixin from "@/mixins/breakpointMixin"
import { Loader, Theme } from "@/constants";
import loggedInMixin from "@/mixins/loggedInMixin"
import menuService from "@/_services/menu-service.js"
import router from "@/router"
import store from "@/store"

export default {
  name: "app-drawer",

  mixins: [breakpointMixin, loggedInMixin],

  components: {
    account,
  },
  computed: {},

  created() {
    this.filterMenuItems()
  },

  data: () => ({
    drawer: false,
    group: null,
    localize: "Espanola",
    menuItems: [],
    theme: "Dark Theme",
    roles: [],
  }),

  methods: {
    onClose() {
      store.commit("toggleDrawer");
    },

    onMenuItem(to) {
      router.push(to);
    },

    onToggleLocalization() {
      // console.log("onToggleLocalization");
      store.commit("toggleLocalization");
    },

    onToggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      store.commit("setDark", this.$vuetify.theme.dark);
      this.theme = this.$vuetify.theme.dark ? Theme.light : Theme.dark;
      this.setThemeText();
    },

    filterMenuItems() {
      // console.log("filterMenuItems()");
      this.menuItems = menuService.get(Loader.menu);
      this.localize = store.getters.getLocalization ? "Espanola" : "English"
      this.setThemeText();
    },

    setThemeText() {
      if(store.getters.getLocalization){
        this.theme = this.$vuetify.theme.dark ? "Light Theme" : "Dark Theme"
      } else {
        this.theme = this.$vuetify.theme.dark ? "Tema Ligero" : "Tema Oscuro"
      }
    }
  },

  watch: {
    drawer: function () {
      if (!this.drawer) {
        store.commit("toggleDrawer");
      }
    },

    "$store.state.drawerOpen"() {
      this.drawer = store.getters.getDrawerOpen;
    },

    "$store.state.localization"() {
      this.filterMenuItems()
    },

    "$store.state.menu"() {
      this.filterMenuItems()
    },

  },

  store,
};
</script>

<style lang="scss" scoped>
.v-icon {
  padding-right: 10px;
}
</style>
